import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'
import { createBrowserHistory } from 'history'
import { configureStore } from '@reduxjs/toolkit'

import appReducer from '@app/state_management/slices'
import liveStreamReducer from '@features/live_stream/state_management/slices'
import menuReducer from '@features/menu_management/state_management/slices'
import storeUserReducer from '@features/store_user/state_management/slices'
import dashboardReducer from '@features/dashboard/state_management/slices'

export const history = createBrowserHistory()

export const rootReducer = combineReducers({
  router: connectRouter(history),
  app: appReducer,
  liveStream: liveStreamReducer,
  menu: menuReducer,
  storeUser: storeUserReducer,
  dashboard: dashboardReducer
  // livePage: livePageReducer,
  // menu: menuReducer
})

const store = configureStore({
  reducer: rootReducer,
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: false
    })
})

export default store
